
<template>

    <div id="nav-row">

        <font-awesome-icon v-if=" isAuth " id="menuIcon" icon="bars" @click=" toggleSideNav " />
    </div>

</template>

<script>

    import FontAwesomeIcon from '@fortawesome/vue-fontawesome';
    import { mapActions, mapGetters } from 'vuex';

    export default {

        name: 'nav-icon',
        computed: {

            ...mapGetters({

                isAuth : 'auth/isAuth'
            }),
        },
        methods: {

            ...mapActions({

                toggleMenu    : 'nav/toggleMenu',
                toggleSideNav : 'nav/toggleSideNav'
            })
        },
        components: {

            FontAwesomeIcon
        },
    }

</script>

<style scoped>

    #nav-row {

        display: flex;
        align-items: center;
        justify-content: flex-end;
        width: 100%;
        height: 45px;
    }

    #menuIcon {

        position: relative;
        right: 10px;
        cursor: pointer;
        color: white;
        height: 40px;
        display: flex;
        width: 25px;
        z-index: 5;
    }

    @media screen and ( min-width: 420px ){

        #nav-row {

            justify-content: flex-start;
            height: 65px;
        }
        #menuIcon {

            left: 10px;
        }

    }

</style>